class YandexMetrika {
  constructor() {
    this.initialized = false;
  }

  init() {
    if (process.env.NODE_ENV === 'development') {
      return;
    }

    if (this.initialized) {
      console.warn('Yandex metrika can only be initialized once.');
      return;
    }

    if (!document) {
      console.warn('yandex metrika can be initialized only on client side.');
      return;
    }

    const script = document.createElement('script');
    const noscript = document.createElement('noscript');

    script.innerHTML = `
    (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    m[i].l=1*new Date();
    for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
    k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
    (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
  
    ym(91614098, "init", {
         clickmap:true,
         trackLinks:true,
         accurateTrackBounce:true,
         webvisor:true
    });
  `;
    noscript.innerHTML = `
    <div><img src="https://mc.yandex.ru/watch/91614098" style="position:absolute; left:-9999px;" alt="" /></div>
  `;

    document.head.insertBefore(script, document.head.childNodes[0]);
    document.body.insertBefore(noscript, document.body.childNodes[0]);
    this.initialized = true;
  }
}

const yandexMetrika = new YandexMetrika();

export default yandexMetrika;
